import { DownloaderContract } from '@/Shared/application'
import { LegalDocumentType } from '@/Shared/domain'
import { textToPdf } from '@/Shared/domain/helpers'
import { useDownloader } from '@/Shared/ui/downloader'
import { useLoader } from '@/Shared/ui/loader'
import { useMetaResponseHandler } from '../../form'

interface IUseDownloader {
  downloadLegalDocument: (id: LegalDocumentType, name?: string) => Promise<void>
  downloadPublicDocument: (id: LegalDocumentType, name?: string) => Promise<void>
}

export const useDownloaderHook = (): IUseDownloader => {
  const { repository } = useDownloader()
  const { startLoading, stopLoading } = useLoader()
  const { handleMetaResponse } = useMetaResponseHandler()

  const downloadLegalDocument = async (
    id: LegalDocumentType,
    name?: string,
  ): Promise<void> => {
    startLoading()

    const response = await DownloaderContract(repository).downloadLegalDocument(id)

    stopLoading()

    if (response.data) textToPdf(response.data.file, name ?? LegalDocumentType[id])
  }

  const downloadPublicDocument = async (
    id: LegalDocumentType,
    name?: string,
  ): Promise<void> => {
    startLoading()

    const response = await DownloaderContract(repository).downloadPublicDocument(id)

    stopLoading()

    if (
      handleMetaResponse(response?.meta, undefined, { notifySuccess: false }) &&
      response.data
    ) {
      textToPdf(response.data.file, name ?? LegalDocumentType[id])
    }
  }

  return {
    downloadLegalDocument,
    downloadPublicDocument,
  }
}
